import { render, staticRenderFns } from "./productlookup.vue?vue&type=template&id=ec6cf176&"
import script from "./productlookup.vue?vue&type=script&lang=js&"
export * from "./productlookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports